import { useRef, useEffect } from 'react';

var useInterval = function useInterval(callback, delay) {
  var savedCallbackRef = useRef();
  useEffect(function () {
    savedCallbackRef.current = callback;
  }, [callback]);
  useEffect(function () {
    var handler = function handler() {
      return savedCallbackRef.current.apply(savedCallbackRef, arguments);
    };

    if (delay !== null) {
      var intervalId = setInterval(handler, delay);
      return function () {
        return clearInterval(intervalId);
      };
    }
  }, [delay]);
};

export default useInterval;
//# sourceMappingURL=interval.esm.js.map
